import { FC } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { Grid, Stack, Typography } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyBranchItem } from "@/features/company/components/company-info/CompanyBranchItem";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { blue } from "@/theme/colors";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { IconDeleteCompanyItem } from "@/assets/icons";
import { useDialog } from "@/hooks/useDialog";
import { ConfirmSaveModal } from "@/components/commons/ConfirmSaveModal";

type TCompanyBranchInfo = {};
export const CompanyBranchInfo: FC<TCompanyBranchInfo> = ({}) => {
  const methods = useFormContext<TCompanyForm>();

  const { control, getValues } = methods;

  const {
    fields: companyBranchArray,
    append: appendCompanyBranch,
    remove: removeCompanyBranch,
  } = useFieldArray({
    control,
    name: "companyBranches",
  });

  const confirmSave = useDialog();

  const handleDeleteItem = async (index: number) => {
    const value = getValues("companyBranches");
    if (value) {
      const off = value[index];
      const checkValue =
        !off.address && !off.city && !off.faxNumber && !off.branchDescription && !off.branchName && !off.prefecture && !off.telNumber && !off.zipCode;
      if (!checkValue) {
        const confirm = await confirmSave.show();
        if (confirm) {
          removeCompanyBranch(index);
        }
      } else {
        removeCompanyBranch(index);
      }
    }
  };

  const isShowAddBtnInList = (index: number) => {
    return index === companyBranchArray.length - 1;
  };

  const isShowAddBtn = () => companyBranchArray.length === 0;

  const addCompanyBranch = () => {
    appendCompanyBranch({
      branchName: "",
      zipCode: "",
      prefecture: "",
      city: "",
      address: "",
      telNumber: "",
      faxNumber: "",
      branchDescription: "",
    });
  };

  return (
    <>
      <InnerBox title={<CompanyFormTitle text="事業所情報" />}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            {companyBranchArray.map((field, index) => (
              <>
                <InnerBox title={<Typography variant="sub16Bold">{`事業所 ${index + 1}`}</Typography>} showDivider={false}>
                  <Stack key={index}>
                    <CompanyBranchItem key={field.id} index={index} />
                  </Stack>
                </InnerBox>
                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  gap={2}
                  sx={{
                    margin: "8px 0 16px 0",
                  }}
                >
                  {isShowAddBtnInList(index) && (
                    <Stack
                      alignItems="center"
                      direction="row"
                      sx={{
                        cursor: "pointer",
                      }}
                      spacing={0.5}
                      onClick={addCompanyBranch}
                    >
                      <AddCircleOutlineIcon
                        sx={{
                          color: blue[80],
                          fontSize: 18,
                        }}
                      />
                      <Typography variant="cap12Light">事業所を追加</Typography>
                    </Stack>
                  )}
                  <Stack
                    alignItems="center"
                    direction="row"
                    sx={{
                      cursor: "pointer",
                    }}
                    spacing={0.5}
                    onClick={() => handleDeleteItem(index)}
                  >
                    <IconDeleteCompanyItem />
                    <Typography variant="cap12Light">削除</Typography>
                  </Stack>
                </Stack>
              </>
            ))}
            {isShowAddBtn() && (
              <Stack
                alignItems="center"
                direction="row"
                sx={{
                  cursor: "pointer",
                }}
                spacing={0.5}
                onClick={addCompanyBranch}
              >
                <AddCircleOutlineIcon
                  sx={{
                    color: blue[80],
                    fontSize: 18,
                  }}
                />
                <Typography variant="cap12Light">事業所を追加</Typography>
              </Stack>
            )}
          </Grid>
        </Grid>
      </InnerBox>
      <ConfirmSaveModal title="削除の確認" open={confirmSave.open} onOk={confirmSave.confirm} onClose={confirmSave.cancel}>
        <Typography component="p" variant="subtitle1">
          「事業所情報」を削除してもよろしいですか？
        </Typography>
      </ConfirmSaveModal>
    </>
  );
};
